import styled from "@emotion/styled"
import colors from "theme/colors"
import { Desktop, Mobile, NewText, TitleWithLine } from "ui"
import { extractProperty } from "utils"

import ActivityDomain from "./ActivityDomain"

const ActivityWrapper = styled.div`
  position: relative;
  ${(props) => props.theme.breakpoints.up("md")} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 50px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    gap: 80px;
  }
`

const StyledTextDiv = styled.div`
  margin-top: 12px;
  ${(props) => props.theme.breakpoints.up("md")} {
    margin-top: 40px;
  }
`

const StyledBox = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  ${(props) => props.theme.breakpoints.up("md")} {
    grid-template-columns: 1fr 1fr;
    gap: 24px;
    margin-top: 40px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    gap: 28px;
  }
`

const StyledActivity = styled.div`
  margin-top: 28px;
  padding-left: 20px;
  padding-right: 20px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-left: 146px;
    padding-right: 146px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    padding-left: 220px;
    padding-right: 220px;
  }
`

function Activity({ data }: { data: any }) {
  const activities = extractProperty(data, "activities")
  const title = extractProperty(data, "title")
  const content = extractProperty(data, "content")

  return (
    <StyledActivity>
      <Desktop>
        <NewText
          component={"h2"}
          desktopFontSize={64}
          desktopFontWeight={500}
          desktopLineHeight={"78px"}
          smallDesktopFontSize={42}
          smallDesktopLineHeight="50px"
        >
          {title}
        </NewText>
      </Desktop>
      <Mobile>
        <TitleWithLine
          title={title}
          titleFontSize={36}
          titleColor={colors.black}
        />
      </Mobile>

      <ActivityWrapper>
        <StyledTextDiv>
          <NewText
            component={"div"}
            desktopFontSize={36}
            mobileFontSize={20}
            mobileLineHeight={"28px"}
            desktopFontWeight={400}
            desktopLineHeight={"50px"}
            smallDesktopFontSize={24}
            smallDesktopLineHeight="34px"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </StyledTextDiv>
        <StyledBox>
          {activities.map((activity: any) => (
            <ActivityDomain
              key={activity.properties[0].propertyValue.value}
              title={activity.properties[0].propertyValue.value}
              text={activity.properties[1].propertyValue.richText.replace(
                /<[^>]+>/g,
                "",
              )} // Remove HTML tags for simple rendering
            />
          ))}
        </StyledBox>
      </ActivityWrapper>
    </StyledActivity>
  )
}

export default Activity
